export default __webpack_public_path__ + "static/media/filter_talent_finder.7bed8417.svg";